// extracted by mini-css-extract-plugin
export default {"block":"block--42b5dd","label":"label--184ed5"};